import * as React from "react";
const MinimalCO2SVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M36.757 34.125h-6.132a.875.875 0 0 0-.875.875v1.313a3.94 3.94 0 1 0 7.88 0V35a.875.875 0 0 0-.873-.875Zm-.875 2.188a2.188 2.188 0 0 1-4.375 0v-.438h4.375v.438ZM25.375 31.5H19.25a.875.875 0 0 0-.875.875v1.313a3.937 3.937 0 1 0 7.875 0v-1.313a.875.875 0 0 0-.875-.875Zm-.875 2.188a2.188 2.188 0 0 1-4.375 0v-.438H24.5v.438ZM22.313 15.75c-1.273 0-2.508 1.128-3.479 3.172-1.523 3.213-2.03 7.984.032 10.5a.876.876 0 0 0 .678.32h5.53a.876.876 0 0 0 .677-.32c2.062-2.516 1.556-7.29.032-10.5-.971-2.044-2.205-3.172-3.47-3.172ZM24.626 28h-4.634c-1.247-1.98-.789-5.764.425-8.325.708-1.495 1.477-2.175 1.896-2.175.419 0 1.183.68 1.892 2.175 1.21 2.56 1.668 6.345.42 8.325Zm6.301 4.375h5.529a.875.875 0 0 0 .678-.32c2.062-2.516 1.555-7.29.032-10.5-.97-2.052-2.205-3.18-3.478-3.18-1.274 0-2.504 1.128-3.475 3.172-1.524 3.213-2.03 7.984.031 10.5a.882.882 0 0 0 .683.328Zm.875-10.075c.706-1.495 1.475-2.175 1.886-2.175.41 0 1.183.68 1.89 2.175 1.215 2.56 1.673 6.344.427 8.325h-4.63c-1.248-1.98-.79-5.764.425-8.325h.002Z"
    />
  </svg>
);
export default MinimalCO2SVG;
